let cache: Record<string, string> = {};
let currentGroup: string | null = null;

export const setTabGroup = (groupId: string) => {
  if (currentGroup !== null && currentGroup !== groupId) {
    cache = {};
  }
  currentGroup = groupId;
};

export const getFiltersForTab = (tabPath: string): string => {
  return cache[tabPath] || '';
};

export const saveFiltersForTab = (tabPath: string, queryString: string) => {
  if (queryString) {
    cache[tabPath] = queryString;
  } else {
    delete cache[tabPath];
  }
};
